type NotUndefined<T> = Exclude<T, undefined>;

export const isNotUndefined = <T>(
  input: undefined | NotUndefined<T>,
): input is NotUndefined<T> => input !== undefined;
